import { emailFunction } from "../util/api.mjs";
import { getAssetTitle } from "../util/api.mjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
/* import all the icons in Free Solid, Free Regular, and Brands styles */
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Button } from "react-bootstrap";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

export default function Links({ component = "ContactMe", assets }) {
  const [show, setShow] = useState(false);
  const [response, setResponse] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (result) => setShow(result);

  const changeHandler = ({ target: { value } }) => setResponse(value);

  const submitHandler = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  library.add(fas, far, fab);

  const vrnt = component === "ContactMe" ? "dark" : "outline-light";

  const testingComponents = window.location.hostname.includes("localhost") ? (
    <>
      {submitted ? (
        <p data-test="does-test-pass">Test result: {response}</p>
      ) : null}
      <Button
        data-test="launch-email-testing-questionaire"
        variant="primary"
        onClick={handleShow}
      >
        Launch email testing questionaire
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Email Application Test</Modal.Title>
        </Modal.Header>
        <Form onSubmit={submitHandler}>
          <Modal.Body>
            <Form.Group
              className="mb-3"
              name="response"
              onChange={changeHandler}
            >
              <Form.Label>
                Select the appropriate response and submit before wait ends.
              </Form.Label>
              <Form.Check
                name="select-email-test-result"
                type="radio"
                id="test-pass-radio"
                label="Default email application opened on desktop."
                value="Passed"
              />
              <Form.Check
                name="select-email-test-result"
                type="radio"
                id="test-fail-radio"
                label="Default email application was not opened."
                value="Failed"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" type="submit" onClick={handleClose}>
              Submit
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  ) : null;

  return (
    <>
      {testingComponents}
      {Object.entries(assets.links).map(([key, value]) => (
        <Button
          key={`link_${key}`}
          id={key}
          href={value.url ? value.url : null}
          target={value.onClick ? null : "_blank"}
          variant={vrnt}
          onClick={value.onClick ? emailFunction : null}
          className="icons"
          data-test="contact-links"
        >
          {component === "ContactMe" ? (
            <Row style={{ flexWrap: "nowrap" }}>
              <Col>
                <FontAwesomeIcon icon={value.icon_name} className="fa-5x" />
              </Col>
              <Col style={{ justifyContent: "center", alignContent: "center" }}>
                <h3>{getAssetTitle(key)}</h3>
              </Col>
            </Row>
          ) : (
            <FontAwesomeIcon icon={value.icon_name} />
          )}
        </Button>
      ))}
    </>
  );
}
